module.exports = require("core-js/library/fn/promise");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/promise.js
// module id = ./node_modules/@babel/runtime/core-js/promise.js
// module chunks = 0